import { createContext } from "@-/com.npmjs.use-context-selectors";
import { defaultError } from "@-/com.npmjs.react-context-default-error";
import { useBrowseWordsPageContextValue } from "#browse-words-page-context-value";

export const BrowseWordsPageContext = createContext(
  defaultError<ReturnType<typeof useBrowseWordsPageContextValue>>("BrowseWordsPageContext"),
);
